<template>
    <div>
        <SoHeader></SoHeader>
        <MyContent></MyContent>
        <div v-html="README" class="markdown-section"></div>
    </div>
</template>

<script>
import axios from 'axios';
import hljs from 'highlight.js';
import MarkdownIt from 'markdown-it';
import MarkdownItCheckbox from 'markdown-it-checkbox';
import SoHeader from './SoHeader';
import MyContent from '../custom/MyContent';

import README from '../../README.md';

// const md = MarkdownIt({
//     highlight(str, lang) {
//         if (lang && hljs.getLanguage(lang)) {
//             try {
//                 return hljs.highlight(lang, str).value;
//             } catch (__) {}
//         }
//         return ''; // use external default escaping
//     }
// }).use(MarkdownItCheckbox);

export default {
    data() {
        return {
            README
        };
    },
    // created() {
    //     axios(README).then((res) => {
    //         this.README = md.render(res.data);
    //     });
    // },
    components: {
        SoHeader,
        MyContent
    }
};
</script>
